<template>
  <div id="app">
    <Menu></Menu> <!-- Navbar -->
    <!-- <ContactUs></ContactUs> Componente fixo, superior esquerdo -->
    <router-view/>
    <Contact></Contact> <!-- Componente de contato, inferior -->

  </div>
</template>

<script>
import Menu from './components/menu/Menu'
import Contact from './components/contact/Contact'

export default {
  name: 'App',

  components: {
    Menu,
    Contact
  }

}
</script>

<style>
.green {
  color: green
}
.red {
  color: red
}
.white {
  color: white
}
.font-bold {
  font-weight: bolder
}
.font-center {
  text-align: center;
}
.divider {
  margin: 3px 0 3px 0;
}
/* 0, 38, 62  23, 162, 184 */
</style>



// WEBPACK FOOTER //
// src/App.vue